import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateChargingStationAssistentDialogContentComponent } from './create-charging-station-assistent-dialog-content/create-charging-station-assistent-dialog-content.component';

@Component({
  selector: 'app-create-chargingstation-assistent',
  template: ''
})
export class CreateChargingStationAssistentDialogComponent implements OnInit {

  constructor(public dialog: NgbModal, private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.openDialog();
  }

  openDialog(): void {
    var customerId = this.activatedRoute.parent.parent.snapshot.params.key;

    const dialogRef = this.dialog.open(CreateChargingStationAssistentDialogContentComponent, { centered: true, backdrop: 'static', size: 'lg' });

    dialogRef.componentInstance.customerId = customerId;

    dialogRef.result.then((result) => {
      this.router.navigate(['../'], { relativeTo: this.activatedRoute });
    }, (backdrop) => {
      this.router.navigate(['../'], { relativeTo: this.activatedRoute });
    });
  }

}
